export default __webpack_public_path__ + "static/media/edit-pencil.564d2979.svg";